// **************************************************************************************

jQuery( document ).ready( electricMenusReady );

// **************************************************************************************

function electricMenusReady() {

	// Show dropbown menus on hover.
	jQuery( 'header nav > ul > li.menu-item-has-children, header nav > ul > li.page_item_has_children' ).on( 'mouseenter', electricShowMenu );

	// Hide dropdown menus on leave.
	jQuery( 'header nav > ul > li.menu-item-has-children, header nav > ul > li.page_item_has_children' ).on( 'mouseleave', electricHideMenu );

	// Show mobile menu on button click.
	jQuery( '.menu-button' ).on( 'click', function () {
		jQuery( 'nav.phone-and-tablet-only' ).addClass( 'visible' );
	} );

	// Hide mobile menu on button click.
	jQuery( '.menu-close' ).on( 'click', function () {
		jQuery( 'nav.phone-and-tablet-only' ).removeClass( 'visible' );
	} );

	// Prepend sub-menu buttons to mobile menu.
	var subMenuButtonHTML = '<a href="#" class="sub-menu-button"></a>';
	jQuery( 'nav.phone-and-tablet-only .menu-item-has-children' ).prepend( subMenuButtonHTML );
	jQuery( 'nav.phone-and-tablet-only .page_item_has_children' ).prepend( subMenuButtonHTML );

	// Toggle mobile sub-menus on click.
	jQuery( '.sub-menu-button' ).on( 'click', electricToggleSubMenu );

}

// **************************************************************************************

// Show dropdown menu.
function electricShowMenu() {

	var li = jQuery( this );
	var menu = li.children().last();
	var menuHeight = 0;
	menu.children().each( function () {
		menuHeight += jQuery( this ).outerHeight();
	} );
	menu.css( 'height', menuHeight ).addClass( 'visible' );

}

// **************************************************************************************

// Hide dropdown menu.
function electricHideMenu() {

	var li = jQuery( this );
	var menu = li.children().last();
	menu.css( 'height', 0 ).removeClass( 'visible' );

}

// **************************************************************************************

// Toggle mobile sub-menu sub-menu.
function electricToggleSubMenu() {

	var button = jQuery( this );

	button.toggleClass( 'active' );
	var subMenu = button.parent().children().last();

	if ( button.hasClass( 'active' ) ) {

		var subMenuHeight = 0;
		subMenu.children().each( function () {
			subMenuHeight += jQuery( this ).outerHeight();
		} );
		subMenu.css( 'height', subMenuHeight );

	} else {

		subMenu.css( 'height', 0 );

	}

}

// **************************************************************************************
